import React from 'react';

type Props = {
  className?: string;
  size?: number;
};

const Icon: React.FC<Props> = ({
  className,
  size = 24,
}: Props) => (
<svg
  data-ffid='icn-wishlist-filled-heart'
  className={className}
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
<path
  d="M12 21.175L10.55 19.875C8.86702 18.358 7.47502 17.05 6.37502 15.95C5.27502 14.85 4.40002 13.862 3.75002 12.987C3.10002 12.112 2.64602 11.308 2.38702 10.574C2.12802 9.83997 1.99902 9.09098 1.99902 8.32398C1.99902 6.75698 2.52402 5.44897 3.57402 4.39897C4.62402 3.34897 5.93202 2.82397 7.49902 2.82397C8.36602 2.82397 9.19102 3.00697 9.97402 3.37397C10.757 3.74097 11.432 4.25697 11.999 4.92397C12.566 4.25697 13.241 3.74097 14.024 3.37397C14.807 3.00697 15.632 2.82397 16.499 2.82397C18.066 2.82397 19.374 3.34897 20.424 4.39897C21.474 5.44897 21.999 6.75698 21.999 8.32398C21.999 9.09098 21.87 9.84098 21.611 10.574C21.352 11.307 20.898 12.112 20.248 12.987C19.598 13.862 18.723 14.85 17.623 15.95C16.523 17.05 15.131 18.358 13.448 19.875L11.998 21.175H12Z"
  className="fill-current"
/>
</svg>

);

export default Icon;
